import React from "react";
import Button from "../../Components/ui/button";

const ThirdExtra = () => {
  return (
    <>
      <div className="relative text-center py-14 px-10 bg-transparent backdrop-blur-xl sm:space-y-5">
        <p className="relative text-3xl font-medium text-[#192027]">
          Inquire Now for the Best Taxation Software - EasyOFFICE
        </p>
        <div>
          <a href="https://www.easyofficesoftware.com/public/demo/demo/EasyOfficeDemoSetup.exe">
            <Button label="Download Demo" />
          </a>
        </div>
      </div>
    </>
  );
};

export default ThirdExtra;
